import 'ui-theme/components/modal/js/modal';

const {modal} = UX;
const show = modal.on.show;
const bodyTag = $('body');
modal.on.show = e => {
    const $target = modal.$target;
    const title = modal.$toggle.data('modal-title');
    const content = modal.$toggle.data('modal-content');
    if (title && title.length) {
        $target.find('.modal__header__title').text(title);
    }
    if (content && content.length) {
        $target.find('.modal__body').html(content);
    }
    show();
};

modal.on.hide = () => {
    bodyTag.removeAttr('data-active');
    modal.accessibility.hide();
    modal.$target.closest("[class*='sticko']").removeClass('js--open');
    const target = $(location.hash);
    if (target.length) {
        const headerHeight = $('.header').height() || 0;
        const actionsBarHeight = $('.actionsbar').height() || 0;
        $(window).scrollTop(target.offset().top - headerHeight - actionsBarHeight);
    }
};
